import "ol/ol.css";
import { Style, Stroke, Fill, Text, Icon } from "ol/style.js";
import ApiService from "services/ApiService";
import { setSourceForGeoJSON } from "map/OlExtension";
import "ol/ol.css";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { fromLonLat, toLonLat } from "ol/proj";
import { ToFeatures } from 'services/GeoJsonService';

export default class LayerForFutureFucMarker extends VectorLayer {
    constructor(map) {
        super({
            name: "layerForFutureFucMarker",
            source: new VectorSource(),
            style: (feature) => this.getDefaultStyle(feature),
        });
        this.map = map;
        this.map?.addLayer(this);
        this.setData();
    }

    setData = function () {
        const layer = this;
        ApiService.get("newdashboard/ftrtrf/GetSelfDriving").then(response => {
            if (response.status === 200) {
                const data = response.data;
                let dataset = new Array();
                for (let i = 0; i < data.length; i++) {

                    let vehicleNum = data[i]['vehicleNum'];
                    let vehicleType = data[i]['vehicleType'];
                    let x = data[i]['lng'];
                    let y = data[i]['lat'];
                    let raceNum = data[i]['raceNum'];

                    let obj = {
                        vehicleNum: vehicleNum, x: x, y: y,
                        vehicleType: vehicleType,
                        raceNum: raceNum, type: "selfdrive"
                    };
                    dataset.push(obj);
                }

                let source = this.getSource()
                source.addFeatures(ToFeatures(dataset))
            }
        })
    }

    // 차량종류별로 이미지 변경
    getDefaultStyle = (feature) => {
        const vehicleNum = parseInt(feature.get('properties')?.vehicleNum);
        let iconSrc = '/images/bis/bus_blue.png';
        switch (vehicleNum) {
            case 2697:
                iconSrc = '/images/dashboard/sonnet_01.png';
                break;
            case 2733:
                iconSrc = '/images/dashboard/sonnet_02.png';
                break;
            case 3101:
                iconSrc = '/images/dashboard/sonnet_03.png';
                break;
            case 3684:
                iconSrc = '/images/dashboard/sonnet_04.png';
                break;
            case 2545:
                iconSrc = '/images/dashboard/sum_01.png';
                break;
            default:
                // iconSrc = '/images/bis/bus_blue.png';
                break;
        }

        return new Style({
            image: new Icon({
                anchor: [0.5, 0.5],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                src: iconSrc,
                scale: 0.8,
            }),
            zIndex: 40
        });
    }

    // updatePositions = function () {
    //     const source = this.getSource();
    //     ApiService.get("newdashboard/gis/GetSelfDriving").then(response => {
    //         if (response.status === 200) {
    //             const data = response.data;

    //             let dataset = data.map(d => ({
    //                 vehicleNum: d.vehicleNum,
    //                 x: d.lng,
    //                 y: d.lat,
    //                 vehicleType: d.vehicleType,
    //                 raceNum: d.raceNum,
    //                 type: "selfdrive"
    //             }));

    //             source.clear(); // 기존 feature 제거
    //             source.addFeatures(ToFeatures(dataset)); // 새로운 위치로 갱신
    //         }
    //     });
    // }
    //     updatePositions = function () {
    //     const source = this.getSource();
    //     ApiService.get("newdashboard/ftrtrf/GetSelfDriving").then(response => {
    //         if (response.status === 200) {
    //             const data = response.data;
    //             console.log('data :::',data)
    //             const now = new Date();

    //             const dataset = data
    //                 .filter(d => {
    //                     if (!d.updtTm) return false;
    //                     const lastUpdate = new Date(d.updtTm);
    //                     const diffSec = Math.abs((now - lastUpdate) / 1000);
    //                     return diffSec <=60; // 통신 정상만 마커 표시
    //                 })
    //                 .map(d => ({
    //                     vehicleNum: d.vehicleNum,
    //                     x: d.lng,
    //                     y: d.lat,
    //                     vehicleType: d.vehicleType,
    //                     raceNum: d.raceNum,
    //                     type: "selfdrive"
    //                 }));
    //             source.clear(); // 기존 feature 제거
    //             source.addFeatures(ToFeatures(dataset)); // 통신 정상인 차량만 갱신
    //         }
    //     });
    // };

    updatePositions = function () {
        const source = this.getSource();
        ApiService.get("newdashboard/ftrtrf/GetSelfDriving").then(response => {
            if (response.status === 200) {
                const data = response.data;
                console.log('data :::', data);

                const dataset = data
                    .filter(d => d.stat === 1) // stat이 1인 경우만 필터링
                    .map(d => ({
                        vehicleNum: d.vehicleNum,
                        x: d.lng,
                        y: d.lat,
                        vehicleType: d.vehicleType,
                        raceNum: d.raceNum,
                        type: "selfdrive"
                    }));

                source.clear(); // 기존 feature 제거
                source.addFeatures(ToFeatures(dataset)); // stat이 1인 차량만 갱신
            }
        });
    };
}
